export default function CustomInput(props) {
  const { placeholder, value, setValue, innerWidth, type } = props

  return (
    <div className='customInput'>
      <input min="0" type={type} value={value < 0 ? 0 : value} onChange={(e) => setValue(e.target.value)} placeholder={placeholder} style={{width:innerWidth}}/>
    </div>
  )
}